import { amplitudeTrack } from '@cw-elements/analytics-provider';
import { analyticsReady } from 'cropwise_accounts/analytics';
import { getProviderType, persistedParam } from './track_auth';

/**
 * Amplitude events for the MFA notice screen: "verification banner viewed" on
 * load, and "dismiss verification banner" for its two dismiss paths (the
 * later/verify-email form and the phone-confirmation form). dismiss_action is
 * read off each form's data-dismiss-action key (set server-side from
 * MfaNoticePagesController#dismiss_action_key / the hardcoded "phone" key),
 * not the localized button label — the label text varies by locale and copy
 * changes, which would otherwise fragment the same action across Amplitude
 * groupings.
 */

const DISMISS_ACTION_LABELS = new Map([
  ['later', "I'll do it later"],
  ['verify_email', "I'll verify my email instead"],
  ['phone', 'Confirm my number'],
]);

const commonProperties = () => ({
  appId: persistedParam('client_id'),
  type: getProviderType(),
});

// Amplitude's contracted property name for this event is snake_case, unlike
// the space-separated keys ('client ID') the rest of this domain uses.
const trackDismiss = (dismissActionKey) => amplitudeTrack('dismiss verification banner', {
  ...commonProperties(),
  // eslint-disable-next-line camelcase -- dismiss_action is the contracted Amplitude property name
  dismiss_action: DISMISS_ACTION_LABELS.get(dismissActionKey),
});

// Fired on page load, so it waits for the provider: anything sent before the
// orchestrator finishes starting is dropped without buffering.
const trackBannerViewed = async () => {
  await analyticsReady;

  amplitudeTrack('verification banner viewed', commonProperties());
};

export const initMfaNoticeEvents = () => {
  const card = document.querySelector('.mfa-notice-card');
  if (!card) return;

  void (async () => {
    try {
      await trackBannerViewed();
    } catch (error) {
      // Background failures must be reported without rejecting the event handler.
      console.error(error); // eslint-disable-line no-console
    }
  })();

  for (const formSelector of ['.mfa-notice-card__later-form', '.mfa-notice-card__phone-form']) {
    const form = document.querySelector(formSelector);
    form?.addEventListener('submit', () => {
      trackDismiss(form.dataset.dismissAction);
    });
  }
};
